import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Instagram } from "lucide-react";

// WhatsApp icoon — eigen SVG (lucide-react heeft geen merk-icoon voor WhatsApp).
const WhatsAppIcon = ({ className = "w-4 h-4" }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.999-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.886 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413"/>
    </svg>
);

const SOCIAL_LINKS = [
    { Icon: Facebook, label: "Facebook", url: "https://www.facebook.com/profile.php?id=61589205575052" },
    { Icon: Instagram, label: "Instagram", url: "https://www.instagram.com/usedcarselection" },
    { Icon: WhatsAppIcon, label: "WhatsApp", url: "https://wa.me/32479442798" },
];

export const Footer = () => (
    <footer className="bg-[#0E2C4D] text-white" data-testid="site-footer">
        <div className="ucs-container py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-4">
                {SOCIAL_LINKS.length > 0 && (
                    <div data-testid="footer-socials">
                        <div className="label-eyebrow text-[#EC6A0A] mb-4">Volg ons</div>
                        <div className="flex gap-3">
                            {SOCIAL_LINKS.map(({ Icon, label, url }) => (
                                <a key={label} href={url} target="_blank" rel="noopener noreferrer"
                                   aria-label={`Used Car Selection op ${label}`}
                                   className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#EC6A0A] hover:text-white transition-colors text-white/85"
                                   style={{ borderRadius: 2 }}
                                   data-testid={`social-${label.toLowerCase()}`}>
                                    <Icon className="w-4 h-4" />
                                </a>
                            ))}
                        </div>
                    </div>
                )}

                <div className="mt-10">
                    <img src="/brand/logo.png" alt="Used Car Selection" className="h-16 w-auto mb-5"
                         style={{ filter: "brightness(0) invert(1)" }} />
                    <p className="text-white/70 text-sm leading-relaxed max-w-sm">
                        Betrouwbare tweedehandswagens, zorgvuldig geselecteerd.<br />
                        Heldere prijzen, eerlijk advies en service waarop u kunt rekenen.
                    </p>
                </div>
            </div>

            <div className="md:col-span-3">
                <div className="label-eyebrow text-[#EC6A0A] mb-4">Snelmenu</div>
                <ul className="space-y-3 text-sm">
                    <li><Link to="/aanbod" className="hover:text-[#EC6A0A]" data-testid="footer-link-aanbod">Aanbod</Link></li>
                    <li><Link to="/inruil#form" className="hover:text-[#EC6A0A]" data-testid="footer-link-inruil">Verkoop uw wagen</Link></li>
                    <li><Link to="/contact" className="hover:text-[#EC6A0A]" data-testid="footer-link-contact">Contact</Link></li>
                </ul>
            </div>

            <div className="md:col-span-5">
                <div className="label-eyebrow text-[#EC6A0A] mb-4">Contact</div>
                <ul className="space-y-3 text-sm text-white/85">
                    <li className="flex items-center gap-3"><MapPin className="w-4 h-4 text-[#EC6A0A]" /> Reedonk 4F, 2880 Bornem</li>
                    <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-[#EC6A0A]" /> +32 479 44 27 98</li>
                    <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-[#EC6A0A]" /> info@usedcarselection.be</li>
                </ul>
                <div className="mt-6 text-xs text-white/50">
                    Op afspraak
                </div>
                <div className="mt-3 text-xs text-white/40">
                    BTW BE 0787.385.523
                </div>
            </div>
        </div>
        <div className="border-t border-white/10">
            <div className="ucs-container py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/50">
                <div>
                    © {new Date().getFullYear()} Used Car Selection. Alle rechten voorbehouden.
                    {" · "}
                    <a href="https://app.emergent.sh/?utm_source=usedcarselection-footer"
                       target="_blank" rel="noopener noreferrer"
                       className="hover:text-white/80 transition-colors"
                       data-testid="footer-emergent-credit">
                        Gemaakt met Emergent
                    </a>
                </div>
                <div className="flex gap-6">
                    <Link to="/admin/login" className="hover:text-white" data-testid="footer-admin-login">Beheer</Link>
                </div>
            </div>
        </div>
    </footer>
);
